import { useState, useEffect, useRef } from "react";

import "./MemosList.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import MemoCard from "../MemoCard/MemoCard";
import { useAnimationMemo } from "../../hooks/useAnimationSection";
import { isFavoriteMemo } from "../../hooks/storageMemoHelper";
import generateKey from "/src/utils/generateKey";
function MemosList({ data, title, postbackAction, view }) {
    const { animationMemo, rotateChevron, openMemo } = useAnimationMemo(view);
    const rotate = rotateChevron ? "close_style_memo " : "open_style_memo "

    const [memos, setMemos] = useState(data);
    const [memosSorted, setMemosSorted] = useState(data);
    const ref = useRef()

    const arrangeListWithFavs = () => {

        let favorites = memos.filter(m => isFavoriteMemo(m.id)).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        let notFavs = memos.filter(m => !isFavoriteMemo(m.id)).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));


        setMemosSorted([...favorites, ...notFavs]);
    }

    useEffect(() => {
        setMemos([...data])
    }, [data])
    useEffect(() => {
        if (memos != null) {
            arrangeListWithFavs();
        }
    }, [memos])

    return (
        <div>
            <div className="memo_list_title">
                {view != null &&
                    <div className="block_title">
                        <IconButton onClick={() => { openMemo() }} className="main-iconButton profil_action main_add-button space_tableButton dashboard_button" icon={"fas fa-chevron-right " + rotate} key={'buttonOpen'} />
                        <div className="dashboard_title" onClick={() => { openMemo() }}>{title}</div>

                    </div>
                }
            </div>
            <div className={"memos_list_container " + animationMemo} ref={ref}>
                <MemoCard mode="create" key={"create-memo-key" + view} view={view} postbackAction={postbackAction} />

                {
                    memosSorted != null && memosSorted.map((memo, i) => {
                        let isFavorite = isFavoriteMemo(memo.id)
                        return <MemoCard memo={memo} key={generateKey()} postbackAction={postbackAction} postbackFavorites={arrangeListWithFavs} isFav={isFavorite} />

                    })
                }
            </div>

        </div >
    );
}

export default MemosList;